import { Component, OnInit, HostBinding, Output, EventEmitter, Input, ViewChild, TemplateRef, Injector, ComponentFactoryResolver, ChangeDetectorRef, Optional, Inject, LOCALE_ID } from '@angular/core';
import { TypeConverter } from '@farris/ide-property-panel';
import { BsModalService } from '@farris/ui-modal';
import { SendMessageOperationComponent } from './send-message-operation/send-message-operation.component';
import { AutoHandleOperationComponent } from "./auto-handle-operation/auto-handle-operation.component";
import {TimeLimitInfo, ExpireOperation, SendMessage, AutoHandle} from './time-limit-control.entity';
import { EditorTypes } from '@farris/ui-datagrid-editors';
import { DatagridComponent } from '@farris/ui-datagrid';
import { MessagerService } from '@farris/ui-messager';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../i18n/assets/lang.resource';
import { UserActivity } from '@gsp-wf/wf-process-model';
import { BpmnModel } from '@edp-pmf/bpmn-model';

@Component({
  selector: 'lib-time-limit-control',
  templateUrl: './time-limit-control.component.html',
  styleUrls: ['./time-limit-control.component.scss'],
  providers: [
     WfLocalePipe,
  ]
})
export class TimeLimitControlComponent implements OnInit {
  @HostBinding('class')
  cls = 'farris-main-area flex-column';

  @Output() closeModal = new EventEmitter<any>();
  @Output() submitModal = new EventEmitter<any>();


  @Input() set value(v: TimeLimitInfo) {
    if (v) {
      if(this.parser(v.dueTime) < 0) {
        v.dueTime = '0';
      }
      this.timeLimitInfo = JSON.parse(JSON.stringify(v));
    } else {
      this.timeLimitInfo = new TimeLimitInfo();
    }
    // 兼容历史数据中的操作类型
    for (const operation of this.timeLimitInfo.expireOperations) {
      if (operation.operationTypeName === undefined) {
        operation.operationTypeName = 'SendMessageExpireOperation';
      }
    }
  }
  @Input() editorParams: any = {};
  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;
  @ViewChild('cell') cell: TemplateRef<any>;
  @ViewChild('grid') grid: DatagridComponent;

  modalConfig = {
    title: this.localePipe.transform("component.timeLimitControl.timedOutOperation"),
    width: 760,
    height: 532,
    showButtons: true
  };

  timeLimitInfo: TimeLimitInfo = new TimeLimitInfo();

  tagCollection = [
    { value: 'constant', text: this.localePipe.transform("component.timeLimitControl.constant") },
    { value: 'scope', text: this.localePipe.transform("component.timeLimitControl.scope") }
  ];

  timeUnitCollection = [
    { value: 'day', text: this.localePipe.transform("component.timeLimitControl.day") },
    { value: 'hour', text: this.localePipe.transform("component.timeLimitControl.hour") },
    { value: 'minute', text: this.localePipe.transform("component.timeLimitControl.minute") }
  ];

  durationTypeCollection = [
    { value: 'BeforeDuration', text: this.localePipe.transform("component.timeLimitControl.BeforeDuration") },
    { value: 'OnDuration', text: this.localePipe.transform("component.timeLimitControl.OnDuration") },
    { value: 'AfterDuration', text: this.localePipe.transform("component.timeLimitControl.AfterDuration") }
  ];

  activityOperationTypeName = [
    { value : 'SendMessageExpireOperation', text: this.localePipe.transform("component.timeLimitControl.SendMessageExpireOperation")},
    { value : 'AutoHandleExpireOperation', text : this.localePipe.transform("component.timeLimitControl.AutoHandleExpireOperation") }
  ];

  processOperationTypeName = [
    { value : 'SendMessageExpireOperation', text: this.localePipe.transform("component.timeLimitControl.SendMessageExpireOperation")}
  ];

  operationTypeName = [];

  timeScopeCollection = [
    {value:'curDay',name:this.localePipe.transform("component.timeLimitControl.curDay")}
  ]
  timeScopeValue = this.timeScopeCollection[0].value
  cols = [];

  location: 'activity' | 'process' = 'activity';

  parser = (val: string | number) => {
    return Number(val);
  }

  durationTypeChange = (data) => {
    if (data && data.value && data.value.value === this.durationTypeCollection[1].value) {
      const operation = this.timeLimitInfo.expireOperations.find(e => e.id === data.rowData.id);
      operation.timeDuration = 0;
  }
}

  constructor(
    private resolver: ComponentFactoryResolver,
    private injector: Injector,
    private modalService: BsModalService,
    private message: MessagerService,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
  }

  ngOnInit() {
    this.location = this.editorParams.location;
    if (this.location === 'activity') {
      this.operationTypeName = this.activityOperationTypeName;
    } else {
      this.operationTypeName = this.processOperationTypeName;
    }
    this.cols = [
      {
        field: 'durationType', width: 80, title: this.localePipe.transform("component.timeLimitControl.durationType"),
        formatter: {
          type: 'enum',
          options: { valueField: 'value', textField: 'text', data: this.durationTypeCollection }
        },
        editor: {
          type: EditorTypes.COMBOLIST,
          options: {
            valueField: 'value', textField: 'text', data: this.durationTypeCollection, idField: 'value', panelHeight: 'auto',
            valueChange: this.durationTypeChange, showClear: false
          }
        },
        validators: [
          { type: 'required', messager: '必填' }
        ]
      },
      {
        field: 'timeDuration', width: 60, title: this.localePipe.transform("component.timeLimitControl.timeDuration"),
        editor: {
          type: EditorTypes.NUMBERBOX, options: { min: 0},
        },
        validators: [
          { type: 'required', messager: '必填' }
        ]
      },
      {
        field: 'timeUnit', width: 60, title: this.localePipe.transform("component.timeLimitControl.timeUnit"),
        formatter: {
          type: 'enum',
          options: { valueField: 'value', textField: 'text', data: this.timeUnitCollection }
        },
        editor: {
          type: EditorTypes.COMBOLIST,
          options: { valueField: 'value', textField: 'text', data: this.timeUnitCollection, idField: 'value', panelHeight: 'auto' }
        },
        validators: [
          { type: 'required', messager: '必填' }
        ]
      },
      {
        field: 'operationTypeName', width: 100, title: this.localePipe.transform("component.timeLimitControl.operationTypeName"),
        formatter: {
          type: 'enum',
          options: { valueField: 'value', textField: 'text', data: this.operationTypeName }
        },
        editor: {
          type: EditorTypes.COMBOLIST,
          options: { valueField: 'value', textField: 'text', data: this.operationTypeName, idField: 'value', panelHeight: 'auto' }
        },
        validators: [
          { type: 'required', messager: '必填' }
        ]
      },
      {
        field: 'sendType', width: 80, title: this.localePipe.transform("component.timeLimitControl.sendType"), template: this.cell,
        validators: [
          { type: 'required', messager: '必填' }
        ]
      }
    ];
  }

  clickOK() {
    this.grid.endCellEdit();
    this.timeLimitInfo.dueTime += '';
    if (this.validator()) {
      const object = { value: this.timeLimitInfo, parameters: null };
      this.submitModal.emit(object);
    }
  }

  clickCancel() {
    this.closeModal.emit();
  }

  private validator(): boolean {
    if ((this.timeLimitInfo.dueTime).indexOf('.') > -1) {
      console.log(this.timeLimitInfo.dueTime);
      this.message.info(this.localePipe.transform("component.timeLimitControl.onlyBeInteger"));
      return false;
    }
    if (this.timeLimitInfo.expireOperations
      && this.timeLimitInfo.expireOperations.length > 0) {
      for (const e of this.timeLimitInfo.expireOperations) {
        if (e.operationTypeName === 'SendMessageExpireOperation') {
          const a = <SendMessage>e;
          if (!a.sendType) {
            this.message.info(this.localePipe.transform("component.timeLimitControl.setOperation"));
            return false;
          }
        }
        if (e.operationTypeName === 'AutoHandleExpireOperation') {
          const a = <AutoHandle>e;
          if (!a.autoHandleType) {
            this.message.info(this.localePipe.transform("component.timeLimitControl.setType"));
            return false;
          }
          if (!a.message) {
            this.message.info(this.localePipe.transform("component.timeLimitControl.setComments"));
            return false;
          }
        }
        if (e.durationType === 'OnDuration' && e.timeDuration !== 0) {
          e.timeDuration = 0;
        }
      }
    }
    return true;
  }

  add() {
    let operation = new ExpireOperation();
    this.timeLimitInfo.expireOperations.push(operation);
    this.grid.loadData(this.timeLimitInfo.expireOperations);
    this.grid.selectRow(operation.id);
  }

  remove() {
    this.grid.endCellEdit();
    const curItem = this.grid.selectedRow;
    if (!curItem) {
      this.message.info(this.localePipe.transform("component.timeLimitControl.selectedOperation"));
      return;
    }
    const i = this.timeLimitInfo.expireOperations.findIndex(a => a.id === curItem.data.id);
    if (i > -1) {
      this.timeLimitInfo.expireOperations.splice(i, 1);
      this.grid.loadData(this.timeLimitInfo.expireOperations);
    }
  }

  editOperation(ctx: any){
    this.grid.endCellEdit();
    if (ctx.rowData.operationTypeName === 'SendMessageExpireOperation'){
      this.sendMassageOperation(ctx);
    }
    if (ctx.rowData.operationTypeName === 'AutoHandleExpireOperation'){
      this.message.confirm(this.localePipe.transform("component.timeLimitControl.notSupportAutomatic")).subscribe(re => re === true ? this.autoHandleOperation(ctx) : null);
    }
  }
  sendMassageOperation(ctx: any) {
    let dialog: any;
    const compFactory = this.resolver.resolveComponentFactory(SendMessageOperationComponent);
    const compRef = compFactory.create(this.injector);
    compRef.instance.location = this.location;
    compRef.instance.value = Object.assign({}, ctx.rowData);
    compRef.instance.submitEmitter.subscribe((re: ExpireOperation) => {
      let operation = this.timeLimitInfo.expireOperations.find(o => o.id === re.id);
      operation = Object.assign(operation, re);
      dialog.close();
    });
    compRef.instance.closeEmitter.subscribe((re: any) => {
      dialog.close();
    });
    const modalConfig = {
      title: this.localePipe.transform("component.timeLimitControl.warningMessage"),
      width: 800,
      height: 515,
      buttons: compRef.instance.footer,
      showButtons: true
    };
    dialog = this.modalService.show(compRef, modalConfig);
  }

  autoHandleOperation(ctx: any) {
    let dialog: any;
    const compFactory = this.resolver.resolveComponentFactory(AutoHandleOperationComponent);
    const compRef = compFactory.create(this.injector);
    compRef.instance.value = Object.assign({}, ctx.rowData);
    compRef.instance.submitEmitter.subscribe((re: ExpireOperation) => {
      let operation = this.timeLimitInfo.expireOperations.find(o => o.id === re.id);
      operation = Object.assign(operation, re);
      dialog.close();
    });
    compRef.instance.closeEmitter.subscribe((re: any) => {
      dialog.close();
    });
    const modalConfig = {
      title: this.localePipe.transform("component.timeLimitControl.automaticProcessing"),
      width: 500,
      height: this.location === 'activity' ? 390 : 460,
      buttons: compRef.instance.footer,
      showButtons: true
    };
    dialog = this.modalService.show(compRef, modalConfig);
  }

  tagSelectChange(data){
    if(data.data.value === 'constant'){
      this.timeLimitInfo.timeUnit = "day";
    }else if(data.data.value === 'scope'){
      this.timeLimitInfo.timeUnit = '';
      this.timeLimitInfo.dueTime = this.timeScopeValue;
    }
  }
  changeTimeScope(data){
    this.timeScopeValue = data;
    this.timeLimitInfo.dueTime = this.timeScopeValue;
  }
}

export class TimeLimitControlConverter implements TypeConverter {
  constructor(
    private localePipe: WfLocalePipe
  ) { }

  convertTo(data: any): string {
    if (data && data.enable) {
      return this.localePipe.transform("component.timeLimitControl.set");
    } else {
      return this.localePipe.transform("component.timeLimitControl.notSet");
    }
  }
}

